import type { CatalogProduct } from "@/lib/catalog";
import { PIX_DISCOUNT, formatBRL, installmentAmount, pixAmount } from "@/lib/catalog";
import { cn } from "@/lib/utils";

type YberaPriceProps = {
  product: CatalogProduct;
  size?: "card" | "pdp";
  className?: string;
};

export function YberaPrice({ product, size = "card", className }: YberaPriceProps) {
  if (product.price == null) return null;

  const pix = pixAmount(product.price);
  const hasList = product.regularPrice != null && product.regularPrice > product.price;
  const off = Math.round(PIX_DISCOUNT * 100);
  const isPdp = size === "pdp";

  return (
    <div className={cn("text-neutral-900", className)}>
      {hasList ? (
        <p className={cn("text-neutral-600 line-through", isPdp ? "text-base" : "text-sm")}>
          {formatBRL(product.regularPrice)}
        </p>
      ) : null}
      <div className="mt-1 flex flex-wrap items-end gap-x-2 gap-y-1">
        <p
          className={cn(
            "font-extrabold tabular-nums leading-none tracking-tight text-neutral-900",
            isPdp ? "text-4xl md:text-5xl" : "text-[1.75rem] leading-none",
          )}
        >
          {formatBRL(pix)}
        </p>
        <span className={cn("mb-0.5 font-semibold", isPdp ? "text-lg" : "text-base")}>no PIX</span>
        <span className="mb-0.5 rounded-full bg-[#1f6b32] px-2.5 py-1 text-xs font-bold uppercase tracking-wide text-white md:text-sm">
          {off}% OFF
        </span>
      </div>
      <p className={cn("mt-2 text-neutral-600", isPdp ? "text-base" : "text-sm")}>
        Ou <strong className="font-bold text-neutral-800">{formatBRL(product.price)}</strong> em até{" "}
        <strong className="font-bold text-neutral-800">
          6x de {formatBRL(installmentAmount(product.price))}
        </strong>{" "}
        sem juros
      </p>
    </div>
  );
}
